function Search() {
    this.extends = [Dialog, _Helpers];
    this.Formatters = this.Formatters ? this.Formatters : Formatters;
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this._resultsId = null;
    this._numResultsId = null;
    this._imageRatio = 0.46206897; // this value also in FeaturedImage.js, RelatedPosts, _ResponsiveTitles.js

    // Variables
    this.linkNode = null;
    this.rssUrl = "";

    this._resultTemplate =
        "<li class='large-3 medium-6 columns'>" +
            "<a class='result' href='{{link}}'>" +
                "<div class='featuredImg'></div>" +
                "<div class='details'>" +
                    "<div class='pubDate'>{{pubDate}}</div>" +
                    "<div class='title'><h4 class='h5 contentContainer'>{{title}}</h4></div>" +
                "</div>" +
            "</a>" +
        "</li>";

    this.init = function() {
        // Preset parameters
        this.close = true;
        this.backgroundClose = false;
        this.onClickClose = $.proxy(this._onClose, this);

        // Execute parent method
        this._super();

        // Modify dialog classes for search
        $(this.node).addClass("mogo-ui-search");
        $(".fixed", this.node).insertBefore($(".icon-arrowdown.dialog", this.node));
        var closeIcon = $(".icon-crosscir", this.node);
        $(closeIcon).addClass("icon-cross");
        $(closeIcon).removeClass("icon-crosscir");
        $(closeIcon).prependTo($(".fixed", this.node)[0]);
        if ($(".fixed .large-12.columns", this.node).length > 0) {
            $(closeIcon).prependTo($(".fixed .large-12.columns", this.node)[0]);
        }
        $(".dialog_container", this.node).addClass("row");
        $(".dialog_container_content", this.node).addClass("large-12 columns");

        // Modify ID containers for search
        this._resultsId = this.id + "_results";
        this._numResultsId = this.id + "_numResults";
        $(".results", this.node).attr("id", this._resultsId);
        $(".numResults", this.node).attr("id", this._numResultsId);

        // Initialize ghost hunter code
        $(".search-field", this.node).ghostHunter({
            results: "#" + this._resultsId,
            numResults: "#" + this._numResultsId,
            rss: this.rssUrl,
            onKeyUp: true,
            info_template: "<div class='numResults'>{{amount}} results found</div>",
            result_template: this._resultTemplate,
            onComplete: $.proxy(this._onSearchComplete, this)
        });

        // Connections
        if (this.linkNode != null) {
            $(this.linkNode).on("click", $.proxy(this.show, this));
        }
    };

    this.initAllReady = function() {
        this._super();
        $(".search-field").mogo().val("");
    };

    this.show = function() {
        this._super();
        $(".search-field", this.node).focus();
        return false;
    };

    this._onClose = function() {
        $(".search-field", this.node).mogo().val("");
    };

    this._onSearchComplete = function(results) {
        var resultContainers = $(".result", this.node);

        // Images
        for (var i = 0; i < results.length; i++) {
            var image = results[i]["featuredImg"];
            var img = null;

            if (image == null) {
                image = "https://mogofiles.s3.amazonaws.com/images/placeholder-thumb.gif";
            }
            $(".featuredImg", resultContainers[i]).append($("<img src='" + image + "'/>"));
        }

        // Dates
        var dates = $("#" + this._resultsId + " .pubDate");
        for (var i = 0; i < dates.length; i++)
            $(dates[i]).html(this.Formatters.formatDate($(dates[i]).html()));
        $("#" + this._resultsId + " li:last").addClass("end");
        this.resize();
    };

    this.resize = function() {
        var titleNodes = $("#" + this._resultsId + " .title", this.node);
        for (var i = 0; i < titleNodes.length; i++)
            this.truncateText(titleNodes[i]);
        var featuredImgs = $(".featuredImg", this.node);
        var width = $(featuredImgs[0]).outerWidth();
        var height = width * this._imageRatio;
        for (var i = 0; i < featuredImgs.length; i++)
            $(featuredImgs[i]).css("height", height + "px");
        this._super();
        var dialogHeight = $(this.node).height();
        var fixedContainerHeight = $(".fixed", this.node).outerHeight();
        $(this._contentDiv).css("height", (dialogHeight - fixedContainerHeight) + "px");
    };
}
